var plotRoute = {

	init: function(obj){

		let coordinates = $(obj).attr("data-coord").split(",");

		this.lat_to = parseFloat(coordinates[0]);
		this.lon_to = parseFloat(coordinates[1]);
        this.zoom = 5;
        this.map = 'plot-route-map';
        this.lat_from = '';
        this.lon_from = '';

        let $this = this;

        if($("#" + this.map).length == 0){
            $("body").append('<div id="'+ this.map +'" style="position: absolute;top: 0;right: 0;margin: -100% -100% 0 0;"></div>');
        }

		navigator.geolocation.getCurrentPosition(function(position) {
            plotRoute.success(position, $this)
        }, function() {
            plotRoute.error($this)
        });

			},

	build: function(obj, html_inner){

		$(".actions-modal-plot-route").remove();

        let html = '<div class="actions-modal actions-modal-plot-route">'
		+ '<div class="actions-group">' 
		+ '<div class="plot-route-modal">'  
        + html_inner
        + '</div>'
		+ '</div>'
		+ '</div>';

		$("body").append(html);

		app.actions.open(".actions-modal-plot-route");

        if($("#yandexMapLink").length > 0){

            scriptLoaderInterface.load("//api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=" + Consts.yandexApiKey, function(){
                ymaps.ready(function(){

                    let myMap = new ymaps.Map(obj.map, {
                        center: [55, 34],
                        zoom: 10,
                    });

                                    let placemark2 = new ymaps.Placemark([obj.lat_from, obj.lon_from]);
                    let placemark1 = new ymaps.Placemark([obj.lat_to, obj.lon_to]);

                                myMap.geoObjects.add(placemark1);
                    myMap.geoObjects.add(placemark2);

                                    myMap.setBounds(myMap.geoObjects.getBounds(), {checkZoomRange:true}).then(function(){
                        if(zoom = myMap.getZoom()){
                            if(myMap.getZoom() > 15){
                                zoom = 15;
                            }

                                        yandexMapLink = 'https://yandex.ru/maps/?mode=routes&rtext='+ obj.lat_from +'%2C'+ obj.lon_from +'~'+ obj.lat_to +'%2C'+ obj.lon_to +'&rtn=1&rtt=auto&ruri=~&z=' + zoom;

                                                        $("#yandexMapLink").attr("href", yandexMapLink);				
                        }
                    });

                });

            });
        }

	},

	success: function(position, obj){

        obj.lat_from = position.coords.latitude;
        obj.lon_from = position.coords.longitude;

        let yandexMapLink = 'https://yandex.ru/maps/?mode=routes&rtext='+ obj.lat_from +'%2C'+ obj.lon_from +'~'+ obj.lat_to +'%2C'+ obj.lon_to +'&rtn=1&rtt=auto&ruri=~&z=' + obj.zoom;
		let googleMapLink = 'https://maps.google.com?saddr=Current+Location&daddr='+ obj.lat_to +','+obj.lon_to;
		let yandexNavigatorAppLink = 'yandexnavi://build_route_on_map?lat_from='+ obj.lat_from +'&lon_from='+obj.lon_from+'&lat_to='+obj.lat_to+'&lon_to='+obj.lon_to;

        let html = '<div class="d-flex plot-route-modal-icons">'
        + '<div class="d-flex plot-route-modal-icons-withtext"><a id="yandexMapLink" href="'+ yandexMapLink +'" target="_blank" class="route-icon icon-ya-map link external"></a><div>Яндекс.Карты</div></div>'
        + '<div class="d-flex plot-route-modal-icons-withtext"><a id="googleMapLink" href="'+ googleMapLink +'" target="_blank" class="route-icon icon-google-map link external"></a><div>Гугл.Карты</div></div>'
        + '<div class="d-flex plot-route-modal-icons-withtext"><a id="yandexNavigatorAppLink" href="'+ yandexNavigatorAppLink +'" target="_blank" class="route-icon icon-ya-navigator link external"></a><div>Яндекс.Нав</div></div>'
        + '</div>';

				plotRoute.build(obj, html);

	},

	error: function(obj){

	            let googleMapLink = 'https://maps.google.com?saddr=Current+Location&daddr='+ obj.lat_to +','+obj.lon_to;

        let html = '<div class="d-flex plot-route-modal-icons">'
        + '<div class="d-flex plot-route-modal-icons-withtext"><a id="googleMapLink" href="'+ googleMapLink +'" target="_blank" class="route-icon icon-google-map link external"></a><div>Гугл-Карты</div></div>'
        + '</div>';

                plotRoute.build(obj, html);

	},

}